import { createSelector } from "reselect";
import { RootState } from "../store";
import { api } from "../api/api";
import { Summary } from "../api/types/get-summaries.types";

export const variantDurations = [10, 90, 365];

export const selectOrgSubscriptionsSummaries = (state: RootState) =>
  api.endpoints.getSummaries.select()(state).data || [];

export const selectIsOnlySummaryTrialPack = createSelector(
  [selectOrgSubscriptionsSummaries],
  (summaries) => {
    if (
      Array.isArray(summaries) &&
      summaries.length === 1 &&
      summaries[0]?.subscription?.variant?.duration === variantDurations[0]
    ) {
      return true;
    }
    return false;
  }
);

export const selectExpiringSoonCount = createSelector(
  [selectOrgSubscriptionsSummaries],
  (summaries) => {
    const array = summaries.map((summary) =>
      summary.is_expiring_soon ? 1 : 0
    );
    return array.reduce((a: number, b: number) => a + b, 0);
  }
);

export const selectExpiredCount = createSelector(
  [selectOrgSubscriptionsSummaries],
  (summaries) => {
    const array = summaries.map((summary) => {
      const {
        is_active: isActive,
        is_expiring_soon: isExpiringSoon,
        is_trial: isTrial,
        is_trial_active: isTrialActive,
      } = summary || {};
      if (isTrial) {
        return isTrialActive ? 0 : 1;
      }
      return !isActive && !isExpiringSoon ? 1 : 0;
    });
    return array.reduce((a: number, b: number) => a + b, 0);
  }
);

export const selectTrialCount = createSelector(
  [selectOrgSubscriptionsSummaries],
  (summaries) => {
    const array = summaries.map((summary) => {
      const { is_trial: isTrial, is_trial_active: isTrialActive } =
        summary || {};
      if (isTrial) {
        return isTrialActive ? 1 : 0;
      }
      return 0;
    });
    return array.reduce((a: number, b: number) => a + b, 0);
  }
);

export const selectAreAllSubscriptionsTrial = createSelector(
  [selectOrgSubscriptionsSummaries],
  (summaries) => {
    const array = summaries.filter((summary) => {
      return summary?.is_trial === true;
    });
    return array.length === 1 && summaries.length === 1;
  }
);

export const selectOrgIdToPayFor = createSelector(
  [selectOrgSubscriptionsSummaries],
  (summaries) => {
    const summary = summaries.find((s) => s?.is_trial === true);
    return summary?.org_id || 0;
  }
);

export const selectIsCRMActive = (
  summaries?: Summary[],
  userOrgIds?: number[]
) => {
  return (
    summaries
      ?.filter?.((summary) => userOrgIds?.includes(summary.org_id))
      ?.some((summary) => {
        return summary?.is_paid_crm_active || summary?.is_trial_crm_active;
      }) || false
  );
};
